<template>
    <UtilitiesWebView url="/visit-the-center/buy-center-tickets" />
</template>
